import React from 'react';
import { FormTextField } from '@uncinc/uncinc-react-kitchen-sink';

const PasswordField = (props) => {
  return (
    <FormTextField type="password" {...props} />
  );
};

export default PasswordField;
